import { JSX } from 'react';
import {
  AirflowIcon,
  AllergyIcon,
  DollarSignIcon,
  GiftIcon,
  LeafIcon,
  PawIcon,
  SnowFlakeIcon,
  SunIcon,
  ThermometerIcon,
  VirusIcon,
} from '../../icons';

export interface SurveyCustomerExperienceOption {
  label: string;
  icon?: JSX.Element;
}

export const currentCustomerExperienceOptions: SurveyCustomerExperienceOption[] =
  [
    {
      label: 'Allergies',
      icon: <AllergyIcon />,
    },
    {
      label: 'Cold Spots',
      icon: <SnowFlakeIcon />,
    },
    {
      label: 'Hot Spots',
      icon: <SunIcon />,
    },
    {
      label: 'Shedding pets',
      icon: <PawIcon />,
    },
  ];

export const customerExperiencePrioritiesOptions: SurveyCustomerExperienceOption[] =
  [
    {
      label: 'Cost',
      icon: <DollarSignIcon />,
    },
    {
      label: 'Efficiency',
      icon: <AirflowIcon />,
    },
    {
      label: 'Even temp',
      icon: <ThermometerIcon />,
    },
    {
      label: 'Eco-friendly',
      icon: <LeafIcon />,
    },
    {
      label: 'Germs',
      icon: <VirusIcon />,
    },
    {
      label: 'Incentives',
      icon: <GiftIcon />,
    },
  ];
